"use client";

import React, { useEffect, useState } from 'react'
import { WrapMain } from '../../../shared/modules/wrap_main'
import '../../../styles/globalstyles.scss';
import './styles.scss';
import { title } from 'process';
import { useDispatch, useSelector } from 'react-redux';
import { mainSlice } from '../../../stateManagement/redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { RoutesWeb } from '../../../shared/interfaces/routes';
import { selectMainState } from "../../../stateManagement/redux";

interface ProjectsCardProps {
  id: string,
  title: string;
  icon: string;
  description: string;
  path: string;
  alert?: string;
}

const cards: ProjectsCardProps[] = [
  {
    id: 'uploadV1',
    title: 'Monitoreo Optimizacion',
    icon: '/assets/icons/leuter_digital.svg',
    description: 'Por este modulo se podrá cargar los archivos de monitoreo de optimización BCP y BM',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_monitoreo
  },
  {
    id: 'uploadV2',
    title: 'Monitoreo Optimizacion Oriente',
    icon: '/assets/images/bcp.jpg',
    description: 'Por este modulo se podrá cargar los archivos de monitoreo de optimización pozos BCP',
    path: RoutesWeb.gerencia_tecnica_operaciones.upload_monitoreoV2
  }
]

const UploadCard = (props: ProjectsCardProps) => {

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const onClickMenu = (path: string, activeProject: string) => {
    dispatch(mainSlice.actions.setActiveProjectId(activeProject))
    localStorage.setItem('activeProjectId', activeProject)
    navigate(path)
  }


  return (
    <div className='card_container' onClick={() => onClickMenu(props.path, props.id)}>
      <img src={props.icon} width={120} height={120} alt='' />
      <div className='card_container__title' > {props.title} </div>
      <div className='card_container__description'> {props.description} </div>
      {props.alert && (
        <div className='card_container__alertSection'>
          <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
          {props.alert}
        </div>
      )}

    </div>
  )
}

const Upload = () => {

  const { configModules } = useSelector(selectMainState);

  const [listOfVisitedModules, setlistOfVisitedModules] = useState<string[]>([])

  useEffect(() => {
    if (Array.isArray(configModules?.enabledUploadModules)) {
      setlistOfVisitedModules(configModules?.enabledUploadModules)
    }
  }, [configModules])


  return (
    <div className='upload_container'>
      <div className='upload_container_title_section'>
        <div className='upload_container_title_section__title'>Subir Archivos de actividades al Sistema</div>
        <div className='upload_container_title_section__detail'>Selecionar el tipo de actividad que ha realizado y suba el o los archivos correspondientes</div>
      </div>
      <div className='upload_container_cards_section'>
        {cards.map((card, i) => {

          if (!listOfVisitedModules.includes(card.id)) return null

          return (
            <UploadCard key={i} icon={card.icon} title={card.title} description={card.description} alert={card.alert} path={card.path} id={card.id} />)
        })}
      </div>
    </div>
  )
}

const index = () => {
  return (
    <WrapMain>
      <Upload />
    </WrapMain>
  )
}

export default index